export const TRANSCRIPT_S3_DIRECTORY = 'transcripts-dubbing';

export const TRANSCRIPT_FILE_FORMAT = ['mp3', 'wav', 'mp4', 'mov'];

export const VIDEO_DUBBING_FILE_FORMAT = ['mp4', 'mov'];

export const AUDIO_ONLY_EXTENSIONS = ['mp3', 'wav'];

// Default model in dubbing/subtitle popups; must match `transcript-audio-models` flag.
export const DEFAULT_TRANSCRIPT_MODEL = 'vbee-transcribe-pro';

export const MAX_AUDIO_SIZE_BYTES = 1 * 1024 * 1024 * 1024; // 1GB

export const MAX_AUDIO_DURATION_SECONDS = 90 * 60; // 90 minutes

// Limits for the "upload existing subtitle" .srt dropzone in the video dubbing
// creation popup (AIV-12773 US-03). Stricter than the generic file dropzone.
export const SUBTITLE_SRT_MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10MB
export const SUBTITLE_MAX_TOTAL_CHARS = 100000;
// A video dubbing project is capped at 90 minutes (BR_7), so the uploaded .srt
// timeline must not exceed this — stricter than the legacy 4h dubbing limit.
export const VIDEO_DUBBING_MAX_DURATION_SECONDS = 90 * 60; // 90 minutes
